/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicableCredit
 */
export interface ApplicableCredit {
    /**
     * 
     * @type {string}
     * @memberof ApplicableCredit
     */
    creditId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicableCredit
     */
    airline?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicableCredit
     */
    remainingAmount?: number;
    /**
     * Amount of credit usable toward this fare
     * @type {number}
     * @memberof ApplicableCredit
     */
    amountApplicable?: number;
    /**
     * 
     * @type {Date}
     * @memberof ApplicableCredit
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicableCredit
     */
    daysUntilExpiry?: number | null;
}

/**
 * Check if a given object implements the ApplicableCredit interface.
 */
export function instanceOfApplicableCredit(value: object): value is ApplicableCredit {
    return true;
}

export function ApplicableCreditFromJSON(json: any): ApplicableCredit {
    return ApplicableCreditFromJSONTyped(json, false);
}

export function ApplicableCreditFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicableCredit {
    if (json == null) {
        return json;
    }
    return {
        
        'creditId': json['credit_id'] == null ? undefined : json['credit_id'],
        'airline': json['airline'] == null ? undefined : json['airline'],
        'remainingAmount': json['remaining_amount'] == null ? undefined : json['remaining_amount'],
        'amountApplicable': json['amount_applicable'] == null ? undefined : json['amount_applicable'],
        'expirationDate': json['expiration_date'] == null ? undefined : (new Date(json['expiration_date'])),
        'daysUntilExpiry': json['days_until_expiry'] == null ? undefined : json['days_until_expiry'],
    };
}

export function ApplicableCreditToJSON(json: any): ApplicableCredit {
    return ApplicableCreditToJSONTyped(json, false);
}

export function ApplicableCreditToJSONTyped(value?: ApplicableCredit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'credit_id': value['creditId'],
        'airline': value['airline'],
        'remaining_amount': value['remainingAmount'],
        'amount_applicable': value['amountApplicable'],
        'expiration_date': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString().substring(0,10),
        'days_until_expiry': value['daysUntilExpiry'],
    };
}

